// root '../../../';

// dependencies
import { Child } from 'pym.js';
import * as d3 from 'd3';
import Swiper from 'swiper';
import Zion from './utils/Zion';
import { classify } from './utils/helpers';

import data from './data/data.json';

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

let swiper;
const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

window.pymChild = new Child({ renderCallback: init, id: pkg.name });

window.onload = () => {
  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);
      if (node) node.innerHTML = meta[id];
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function populateSlider() {
  const swiperWrapper = d3.select('div.swiper-wrapper').html('');
  const slides = swiperWrapper.selectAll('.swiper-slide')
    .data(data)
    .enter()
    .append('div')
    .attr('class', 'swiper-slide')
    .attr('aria-labelledby', (d, i) => `justice-name-${i}`);

  const card = slides.append('div')
    .attr('class', 'card');

  // Portrait overlapping top of card
  const portrait = card.append('div')
    .attr('class', 'profile-portrait');
  portrait.append((d) => {
    const el = document.createElement(d.photo ? 'img' : 'div');
    if (d.photo && el.tagName === 'IMG') {
      el.src = d.photo;
      el.alt = d.name;
    }
    return el;
  }).attr('class', d => `profile-photo${d.smaller_headshot ? ' profile-photo--smaller' : ''}`);

  // Name centered under portrait
  card.append('h3')
    .attr('class', 'profile-name')
    .attr('id', (d, i) => `justice-name-${i}`)
    .text(d => d.name);

  // Two-column layout: ancestry metadata | quote
  const content = card.append('div').attr('class', 'card-content');

  // Left column: either ancestry_notes (text only) OR Maternal/Paternal with flags
  const leftCol = content.append('div')
    .attr('class', d => `card-meta-col${d.ancestry_notes ? ' card-meta-col--notes' : ''}`);
  leftCol.each(function (d) {
    const col = d3.select(this);
    if (d.ancestry_notes) {
      col.append('p').attr('class', 'ancestry-notes').text(d.ancestry_notes);
      if (d.africa_flag) {
        col.append('img')
          .attr('class', 'ancestry-africa-flag')
          .attr('src', './images/africa.png')
          .attr('alt', '');
      }
    } else {
      const metaRow1 = col.append('div').attr('class', 'meta-row');
      metaRow1.append('span').attr('class', 'meta-label').text('Maternal');
      if (!d.hide_maternal_flag && !d.hide_flags) {
        metaRow1.append('span').attr('class', 'meta-value meta-flags').text(d => d.maternal_flag || '—');
      }
      metaRow1.append('span').attr('class', 'meta-country').text(d => d.maternal || '');
      const metaRow2 = col.append('div').attr('class', 'meta-row');
      metaRow2.append('span').attr('class', 'meta-label').text('Paternal');
      if (!d.hide_paternal_flag && !d.hide_flags) {
        metaRow2.append('span').attr('class', 'meta-value meta-flags').text(d => d.paternal_flag || '—');
      }
      metaRow2.append('span').attr('class', 'meta-country').text(d => d.paternal || '');
    }
  });

  // Vertical divider
  content.append('div').attr('class', 'card-divider');

  // Right column: quote box
  const quoteCol = content.append('div').attr('class', 'card-quote-col');
  quoteCol.append('div')
    .attr('class', 'quote-box')
    .classed('quote-box--quote', d => d.type === 'quote')
    .classed('quote-box--blurb', d => d.type === 'blurb')
    .classed('quote-emphasis', d => d.emphasis)
    .each(function (d) {
      const box = d3.select(this);
      if (d.type === 'quote') {
        box.append('img')
          .attr('class', 'quote-tail')
          .attr('src', './images/tail.png')
          .attr('alt', '');
      }
      box.append('p')
        .attr('class', d => `quote-text quote-text--${d.type}`)
        .text((d) => {
          const text = d.quote || 'Quote goes here';
          if (d.quote_formatted) return text;
          return d.type === 'quote' ? `\u201C${text}\u201D` : text;
        });
    });
}

function init() {
  populateSlider();

  swiper = new Swiper('.swiper', {
    direction: 'horizontal',
    cssMode: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    freeMode: {
      enabled: true,
    },
  });

  const swiperEl = document.querySelector('.swiper');
  const wrapperEl = document.querySelector('.swiper-wrapper');
  if (wrapperEl) {
    const checkScrollEnd = () => {
      const atEnd = wrapperEl.scrollLeft + wrapperEl.clientWidth >= wrapperEl.scrollWidth - 2;
      swiperEl.classList.toggle('at-end', atEnd);
    };
    wrapperEl.addEventListener('scroll', checkScrollEnd);
    checkScrollEnd();
  }
}
